import http from '@/plugins/axios/axios';

export default class CalculoPontoService {

    calcular(requisicao) {       
        return http.post('/api/calculo-ponto/calcular', requisicao);
    }

    calcularFlexivel(requisicao) {       
        return http.post('/api/calculo-ponto/calcular-flexivel', requisicao);
    }  

    calcularPagina(requisicao) {       
        return http.post('/api/calculo-ponto/calcular-pagina', requisicao);
    }

    calcularPaginaFlexivel(requisicao) {       
        return http.post('/api/calculo-ponto/calcular-pagina-flexivel', requisicao);
    }     

    buscarFuncionario(requisicao) {       
        return http.post('/api/calculo-ponto/buscar-funcionario', requisicao);
    } 

    getQuantidadeFuncionarios(requisicao) {       
        return http.post('/api/calculo-ponto/quantidade-funcionarios', requisicao);
    } 

    listaDatasPeriodoFechamento(requisicao) {       
        return http.post('/api/calculo-ponto/listar-datas-periodo-fechamento', requisicao);
    } 
}